const features = [
  { icon: 'ri-heart-line', label: '品牌理念' },
  { icon: 'ri-leaf-line', label: '天然布料' },
  { icon: 'ri-scissors-cut-line', label: '精工剪裁' },
  { icon: 'ri-recycle-line', label: '永續時尚' },
  { icon: 'ri-customer-service-2-line', label: '專屬服務' },
];

export default function AboutUs() {
  const handleExplore = () => {
    const el = document.querySelector('#location');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="about" className="bg-[#1E1610] py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto text-center">
        <p className="font-sans-body text-[1rem] text-cream-300/70 tracking-widest mb-4 font-light">
          ABOUT OUR BRAND
        </p>

        <h2 className="font-serif-title text-[1.5rem] md:text-[2.125rem] text-cream-100 font-semibold leading-[1.4] mb-6 max-w-2xl mx-auto">
          時尚不應是奢侈，<br />而是每位女性日常的選擇權
        </h2>

        <p className="font-sans-body text-[1.1875rem] text-cream-200/60 leading-[1.75] max-w-xl mx-auto mb-10">
          我們深信，每一位女性都值得擁有高品質的服飾，卻不必為此傾盡所有。透過直接與品牌合作、精選換季庫存與下架精品，讓妳以驚喜的 Outlet 價格，穿出自信與品味。
          <br /><br />
          台中旗艦門市提供專業搭配諮詢，所有商品 100% 正品保證，讓購物成為一種享受，而非負擔。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <button
            onClick={handleExplore}
            className="whitespace-nowrap font-sans-body text-[1.0625rem] font-medium bg-white text-warm-900 px-8 py-3 rounded-full hover:bg-cream-100 transition-all duration-300 cursor-pointer"
          >
            探訪門市
          </button>
          <button
            onClick={() => document.querySelector('#collections')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap font-sans-body text-[1.0625rem] font-medium border border-white/40 text-white px-8 py-3 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            瀏覽商品
          </button>
        </div>

        {/* Feature Cards */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3">
          {features.map((f) => (
            <div
              key={f.label}
              className="flex items-center gap-3 bg-white/8 border border-white/10 rounded-xl px-5 py-3"
            >
              <span className="w-6 h-6 flex items-center justify-center">
                <i className={`${f.icon} text-gold-300 text-lg`}></i>
              </span>
              <span className="font-sans-body text-[1rem] text-cream-100 font-medium whitespace-nowrap">
                {f.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
